import { render, staticRenderFns } from "./parameterInfo.vue?vue&type=template&id=1c8d97ea&scoped=true"
import script from "./parameterInfo.vue?vue&type=script&lang=js"
export * from "./parameterInfo.vue?vue&type=script&lang=js"
import style0 from "./parameterInfo.vue?vue&type=style&index=0&id=1c8d97ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8d97ea",
  null
  
)

export default component.exports